// ordered alphabetically
export const CheckoutEvents = {
  EVENTS: {
    ACCOUNT_CREATED: 'Account Created',
    ACCOUNT_SETUP_COMPLETED: 'Account Setup Completed',
    AUDIO_REFERRAL_SOURCES_COMPLETED: 'Audio Referral Sources Completed',
    CART_EMAIL_CAPTURED_GOLD_STANDARD: 'Cart Email Captured',
    CART_EMAIL_PREFILLED: 'Cart Email Prefilled',
    CART_EMAIL_STARTED: 'Cart Email Started',
    CART_EMAIL_VIEWED: 'Viewed Cart Email Step',
    CART_FIELD_CLICKED: 'Cart Field Clicked',
    CART_START: 'Cart Start',
    CHECKOUT_BACK_EXIT: 'Checkout Back Exit',
    CHECKOUT_BACK_STEP: 'Checkout Back Step',
    CHECKOUT_CTA_CLICKED: 'Checkout CTA Clicked',
    CHECKOUT_STEP_COMPLETED: 'Checkout Step Completed',
    EXITED_CART_WITHOUT_PURCHASE: 'Exited cart without purchase',
    PASSWORD_HIDE: 'Password Hide',
    PASSWORD_SHOW: 'Password Show',
    PAYMENT_FAILURE: 'Payment Failure',
    PAYMENT_INFO_STEP_VIEWED_GOLD_STANDARD: 'Payment Info Step Viewed',
    PAYPAL_SUBSCRIPTION_BUTTON_CLICKED: 'PayPal Subscription Button Clicked',
    PAYPAL_SUBSCRIPTION_BUTTON_RENDERED: 'PayPal Subscription Button Rendered',
    PAYPAL_SUBSCRIPTION_OPTION_CLICKED: 'PayPal Subscription Option Clicked',
    PAYPAL_SUBSCRIPTION_PAYMENT_CANCELLED:
      'PayPal Subscription Payment Cancelled',
    PLANS_PAGE_VIEWED_GOLD_STANDARD: 'Plans Page Viewed',
    POSTAL_VERIFICATION: 'Postal Verification',
    PRODUCT_ADDED: 'Product Added',
    REFERRAL_SOURCES_COMPLETED: 'Referral Sources Completed',
    SOCIAL_VENDOR_LOG_IN: 'Social Vendor Log In',
    SOCIAL_VENDOR_LOG_IN_INITIATED: 'Social Vendor Log In Initiated',
    STRIPE_RENDERED: 'Stripe Rendered',
    STRIPE_LINK_LOGGED_IN: 'Stripe Link Logged In',
    STRIPE_LINK_LOGGED_OUT: 'Stripe Link Logged Out',
    PAYMENT_INTENT_REQUIRED_ACTION_STARTED:
      'Payment Intent Required Action Started',
    BRAINTREE_CC_RENDERED: 'Braintree CC Rendered',
    APPLE_PAY_RENDERED: 'Apple Pay Rendered',
    GIFT_PURCHASE_INFO_STEP: 'Gift Purchase Info Step',
    GUEST_PASS_SKIPPED: 'Guest Pass Skipped',
    INITIATE_CHECKOUT_GOLD_STANDARD: 'Initiate Checkout',
    MULTI_GIFT: {
      CHECKOUT_SUMMARY_ACCORDION_CLICKED:
        'Multi-gift Checkout Summary Accordion Clicked',
      QUANTITY_INPUT_CLICKED: 'Multi-gift Quantity Input Clicked',
      QUANTITY_INPUT: 'Multi-gift Quantity Input',
      QUANTITY_EDIT_CLICKED: 'Multi-gift Quantity Edit Clicked',
    },
  },
  PAGES: {
    VALUE_PRIMER: 'Checkout Step: Value Primer',
    ACCOUNT_CREATION: 'Checkout Step: Account Creation',
    PAYMENT_STEP: {
      CHOOSE_PAYMENT: 'Checkout Step: Choose Payment',
      PAYMENT_ENTRY: 'Checkout Step: Payment Entry',
      IN_CC_INPUT: 'Checkout Step: Credit Card Input',
      IN_PAYPAL_INPUT: 'Checkout Step: PayPal Input',
      IN_APPLE_PAY_INPUT: 'Checkout Step: Apple Pay',
    },
    CART_REGISTRATION: 'Cart Registration',
    EMAIL_CORRECTION: 'Checkout Step: Email Correction',
    EMAIL_CORRECTION_VERIFICATION_SENT:
      'Checkout Step: Email Correction Verification Sent',
    REFERRAL: 'Referral Sources',
    AUDIO_REFERRAL: 'Audio Referral Sources',
    MULTI_GIFT_STEP: 'Checkout Step: Multi Gift Step',
    GUEST_PASS: {
      INPUT: 'Checkout Step: Guest Pass Input',
      SKIP: 'Checkout Step: Guest Pass Skip Screen',
      SUCCESS: 'Checkout Step: Guest Pass Success Screen',
    },
    ADD_ONS: 'Certificate Post Purchase Add-on Screen',
    ADD_ONS_CONFIRMATION: 'Certificate Post Purchase Add-on Thanks Screen',
  },
} as const

export const CHECKOUT_TRACK_STEP_NAMES = {
  EMAIL_SUBMISSION: 'email_submission',
  PAYMENT: 'payment',
} as const

export const EMAIL_STARTED_TYPES = {
  EMAIL: 'email',
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
} as const

export const CART_EMAIL_PREFILL_SOURCES = {
  EMAIL_CAPTURED: 'email_captured',
  CART_EMAIL_COOKIE: 'cart_email_cookie',
  NONE: 'none',
} as const

export const FooterEvents = {
  NAV_CLIKED: 'Footer Navigation Clicked',
} as const

export const TRACK_CART_PAYMENT_MODAL_TYPES = {
  CREDIT_CARD: 'credit_card_payment_tab',
  PAYPAL: 'paypal_payment_tab',
} as const

// How the user arrived back on /checkout. A bfcache restore reuses the existing
// document, so it produces no new navigation-timing entry and has to be detected
// separately from an ordinary back/forward navigation.
export const CHECKOUT_BACK_NAV_TYPES = {
  BACK_FORWARD: 'back_forward',
  BFCACHE: 'bfcache',
} as const

export const TRACK_EMAIL_MODAL_TYPE = {
  LOG_IN: 'email_cart_log_in',
  SIGN_UP: 'email_cart_sign_up',
} as const

export const TRACK_PAYMENT_METHODS = {
  CREDIT_CARD: 'Credit_Card',
  PAYPAL: 'PayPal',
  APPLE_PAY: 'Apple Pay',
} as const

export const TRACK_PAYMENT_PROVIDERS = {
  CREDIT_CARD: 'Stripe',
  PAYPAL: 'Braintree',
  APPLE_PAY: 'Apple Pay',
  BRAINTREE_CC_FAILOVER: 'Braintree CC Failover', // used when braintree_cc_failover feature flip is on. See web/ui/payments/src/components/CreditCardOrderForm/CreditCardOrderForm.tsx
} as const
